import { createAction } from 'redux-actions-helpers'
import { BlockType } from '../LessonPage/types'
import { DataCreateBlockType, UpdateBlockDataType } from './types'

export const fetchModuleScreenBlocks = createAction(
  '@@admin-module-screen-blocks/FETCH_MODULE_SCREEN_BLOCKS',
  (sid: string): any => ({ sid })
)

export const fetchModuleScreenBlocksSuccess = createAction(
  '@@admin-module-screen-blocks/FETCH_MODULE_SCREEN_BLOCKS_SUCCESS',
  (result: BlockType[]): any => ({ result })
)

export const fetchModuleScreenBlocksFailure = createAction(
  '@@admin-module-screen-blocks/FETCH_MODULE_SCREEN_BLOCKS_FAILURE',
  (error: string): any => ({ error })
)

export const updateBlock = createAction(
  '@@admin-module-screen-blocks/UPDATE_BLOCK',
  (sid: string, block_id: string, data: UpdateBlockDataType): any => ({
    sid,
    block_id,
    data,
  })
)

export const updateBlockSuccess = createAction(
  '@@admin-module-screen-blocks/UPDATE_BLOCK_SUCCESS'
)

export const updateBlockFailure = createAction(
  '@@admin-module-screen-blocks/UPDATE_BLOCK_FAILURE',
  (error: string): any => ({ error })
)

export const sortBlocks = createAction(
  '@@admin-module-screen-blocks/SORT_BLOCKS',
  (lid: string, ids: string[]): any => ({
    lid,
    ids,
  })
)

export const sortBlocksSuccess = createAction(
  '@@admin-module-screen-blocks/SORT_BLOCKS_SUCCESS'
)

export const sortBlocksFailure = createAction(
  '@@admin-module-screen-blocks/SORT_BLOCKS_FAILURE',
  (error: string): any => ({ error })
)

export const sortModuleScreenBlocks = createAction(
  '@@admin-module-screen-blocks/SORT_MODULE_SCREEN_BLOCK',
  (sid: string, ids: string[]): any => ({
    sid,
    ids,
  })
)

export const sortModuleScreenBlocksSuccess = createAction(
  '@@admin-module-screen-blocks/SORT_MODULE_SCREEN_BLOCK_SUCCESS'
)

export const sortModuleScreenBlocksFailure = createAction(
  '@@admin-module-screen-blocks/SORT_MODULE_SCREEN_BLOCK_FAILURE',
  (error: string): any => ({ error })
)

export const deleteBlock = createAction(
  '@@admin-module-screen-blocks/DELETE_BLOCK',
  (sid: string, block_id: string): any => ({
    sid,
    block_id,
  })
)

export const deleteBlockSuccess = createAction(
  '@@admin-module-screen-blocks/DELETE_BLOCK_SUCCESS'
)

export const deleteBlockFailure = createAction(
  '@@admin-module-screen-blocks/DELETE_BLOCK_FAILURE',
  (error: string): any => ({ error })
)

export const createBlock = createAction(
  '@@admin-module-screen-blocks/CREATE_BLOCK',
  (sid: string, data: DataCreateBlockType, position: number): any => ({
    sid,
    data,
    position,
  })
)

export const createBlockSuccess = createAction(
  '@@admin-module-screen-blocks/CREATE_BLOCK_SUCCESS'
)

export const createBlockFailure = createAction(
  '@@admin-module-screen-blocks/CREATE_BLOCK_FAILURE',
  (error: string): any => ({ error })
)

export const fetchSimpleTaskNotion = createAction(
  '@@admin-module-screen-blocks/FETCH_SIMPLE_TASK_NOTION',
  (simple_task_id: string): any => ({ simple_task_id })
)

export const fetchSimpleTaskNotionSuccess = createAction(
  '@@admin-module-screen-blocks/FETCH_SIMPLE_TASK_NOTION_SUCCESS'
)

export const fetchSimpleTaskNotionFailure = createAction(
  '@@admin-module-screen-blocks/FETCH_SIMPLE_TASK_NOTION_FAILURE',
  (error: string): any => ({ error })
)

export const fetchNotion = createAction(
  '@@admin-module-screen-blocks/FETCH_NOTION',
  (block_id: string, notion_page_id: string): any => ({
    block_id,
    notion_page_id,
  })
)

export const fetchNotionSuccess = createAction(
  '@@admin-module-screen-blocks/FETCH_NOTION_SUCCESS'
)

export const fetchNotionFailure = createAction(
  '@@admin-module-screen-blocks/FETCH_NOTION_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@admin-module-screen-blocks/DESTROY')
